import { Trans, useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";

import { Button } from "../../../components/ui-kit/button";
import { CopyButton } from "../../../components/ui-kit/copy-button";
import { Dialog } from "../../../components/ui-kit/dialog";
import { PPGQuickLook } from "../../../models/quick-look-analyses";

export const PPGShareDialog = observer(function PPGShareDialog(props: {
  ppgQuickLook: PPGQuickLook;
}) {
  const { t } = useLingui();
  return (
    <Dialog open={props.ppgQuickLook.sharePopupOpen}>
      <p className="mt-4 mb-4">
        <Trans>
          Share <em>QuickLook</em> analysis.
        </Trans>
      </p>
      <p className="mt-4 mb-4">
        <Trans>
          This link is valid for <strong>1 hour</strong>.
        </Trans>
      </p>
      <p className="mt-4 mb-4">
        <a
          href={props.ppgQuickLook.sharedAnalysisUrl}
          className="truncate inline-block max-w-[300px]"
          target="_blank"
          rel="noreferrer"
        >
          {props.ppgQuickLook.sharedAnalysisUrl}
        </a>
      </p>
      <CopyButton
        value={props.ppgQuickLook.sharedAnalysisUrl}
        label={t`Copy Link`}
        copiedLabel={t`Link Copied!`}
        variant="default"
      />
      <Button
        onClick={() => {
          props.ppgQuickLook.sharePopupOpen = false;
        }}
      >
        <Trans>Close</Trans>
      </Button>
    </Dialog>
  );
});
